import { RouteComponentProps } from "@reach/router";
import { FunctionComponent, lazy } from "react";
import { ErrorBoundary } from "react-error-boundary";
import ErrorFallback from "../../shared/ErrorFallback";
import InfoPage from "../../info/InfoPage";

interface IParams {
	mangaId: string;
}

interface IProps extends RouteComponentProps<IParams> {
	loggedIn: boolean | undefined;
	loading: React.ReactElement;
}

const LazyTranslation = lazy(() => import(/* webpackChunkName: "Translation" */ "./Translation"));
// const LazyPost = lazy(() => import(/* webpackChunkName: "TranslationPost" */ "./Post"));

const TranslationPage: FunctionComponent<IProps> = (props) => {
	// eslint-disable-next-line @typescript-eslint/no-unused-vars
	const { loggedIn, path, loading, mangaId } = props;

	if (loggedIn === undefined) {
		return loading;
	}

	if (!loggedIn) {
		return <InfoPage />;
	}

	// if (articleId) {
	// 	return <ErrorBoundary FallbackComponent={ErrorFallback}>
	// 		<LazyPost articleId={articleId} />
	// 	</ErrorBoundary>;
	// }

	return <ErrorBoundary FallbackComponent={ErrorFallback}>
		<LazyTranslation mangaId={mangaId ? Number(mangaId) : null} loading={loading} />
	</ErrorBoundary>;
};

export default TranslationPage;